export class FinancialCalculatorService {
    /**
     * חישוב ערך עתידי (Future Value) לפי נוסחת NumPy
     * @param rate - תשואה שנתית (לדוגמה: 5% = 0.05)
     * @param nper - מספר תקופות (שנים/חודשים)
     * @param pmt - תשלום תקופתי (לדוגמה חודשי או שנתי)
     * @param pv - סכום התחלתי
     * @returns ערך עתידי (FV)
     */
    static fv(rate: number, nper: number, pmt: number, pv: number): number {
      if (rate < -1) {
        throw new Error('Rate must be greater than -1');
      }
      if (nper < 0) {
        throw new Error('Number of periods must be positive');
      }
        if (rate === 0) {
        return pv + pmt * nper;
      }
      // ✅ חישוב ערך עתידי לפי נוסחת NumPy
      const futureValue =
        pv * Math.pow(1 + rate, nper) +
        (pmt * (Math.pow(1 + rate, nper) - 1)) / rate;
  
      return futureValue;
    }

    /**
 * חישוב ערך עתידי לפי תשואות חודשיות משתנות (באחוזים)
 * @param yields תשואות חודשיות באחוזים (למשל [1.5, -0.5, 2])
 * @param pv סכום השקעה התחלתי
 * @returns ערך עתידי בסיום התקופה
 */
  static futureValueFromMonthlyYields = (yields: number[], pv: number): number => {
    if (!Array.isArray(yields) || yields.length === 0) return pv;

    return yields.reduce((acc, monthlyYield) => {
      const r = Number(monthlyYield) / 100;
      if (isNaN(r)) return acc;
      return acc * (1 + r);
    }, pv);
  };
  }
  